export default "/images/628b70a3932e9856b505c6e350d39d26.png";